/**
 * Preferenze di accessibilita (Person.accessibility, contratti) -> attributi sulla radice.
 * I token in tokens.css reagiscono agli attributi: nessun componente legge le preferenze.
 *   data-text-scale="0.9|1.2|1.4" · data-contrast="alto" · data-motion="ridotto"
 */
import type { Accessibility } from '@mamma/contracts'

export const TEXT_SCALES = [0.9, 1, 1.2, 1.4] as const
export type TextScale = (typeof TEXT_SCALES)[number]

export const DEFAULT_ACCESSIBILITY: Accessibility = {
  text_scale: 1,
  high_contrast: false,
  reduce_motion: false,
}

export function isTextScale(value: number): value is TextScale {
  return (TEXT_SCALES as readonly number[]).includes(value)
}

export function applyAccessibility(prefs: Accessibility, root: HTMLElement = document.documentElement): void {
  const scale = isTextScale(prefs.text_scale) ? prefs.text_scale : 1
  if (scale === 1) root.removeAttribute('data-text-scale')
  else root.setAttribute('data-text-scale', String(scale))

  if (prefs.high_contrast) root.setAttribute('data-contrast', 'alto')
  else root.removeAttribute('data-contrast')

  if (prefs.reduce_motion) root.setAttribute('data-motion', 'ridotto')
  else root.removeAttribute('data-motion')
}
